import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DownloadForOfflineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"download_for_offline"}/>
}
